/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useEffect, useState } from "react";
import { LayoutContext } from "../../components/layout";
import fetchHelper from "../../services/fetchHelper";
import { CPTCheckbox } from "./CPTCheckbox";
import cn from "classnames";

export function DiagnosisCodes({ showCPT }) {
  const { headerDetails: userInfo } = useContext(LayoutContext);
  const [show, setShow] = useState(showCPT);
  const [diagnosisCodes, setDiagnosisCodes] = useState({ esignStatements: [] });

  useEffect(() => {
    fetchDiagnosisCodes();
  }, []);

  useEffect(() => {
    setShow(showCPT);
  }, [showCPT]);

  const fetchDiagnosisCodes = async () => {
    try {
      const allDiagnosisCodes = await fetchHelper.get({
        url: `/patientmanagement/rest/v2/interrogations/${userInfo.id}/diagnostic_code`,
      });
      const codesToDisplay = allDiagnosisCodes.map((item) => ({
        interrogationId: item.interrogationId,
        codeId: item.diagnosticCodeId,
        codeName: item.diagnosticCodeName,
        selected: item.selected,
      }));
      setDiagnosisCodes({ apiName: "diagnostic_code", esignStatements: codesToDisplay });
    } catch {
      setDiagnosisCodes({ esignStatements: [] });
    }
  };

  return (
    <fieldset id="diagonosis-codes-section">
      <div className="grp-hdr">
        <button
          className="btn btn-sm btn-hide-section "
          onClick={() => setShow((prev) => !prev)}
          type="button"
        >
          <i className={cn("ti", { "ti-eye-slash": show }, { "ti-eye": !show })} />
          <span>{show ? "Hide" : "Show"}</span>
        </button>
        <h3>Diagnosis Codes</h3>
      </div>
      <CPTCheckbox data={diagnosisCodes} globalShow={show} suggestions={[]} showTitle={false} />
    </fieldset>
  );
}
